export default __webpack_public_path__ + "f84cc623213ec152b43b524f6113dd42.ttf";